import {inject} from '@angular/core';
import {BaseSpringServiceCB, SpringRestService} from '@aiknow-srl/aik-angular-sdk';
import {Observable} from 'rxjs';
import {GlobalModelService} from "../GlobalModel.service";


export abstract class BaseService {

  // ******************************************************
  //                 Dependency Injection
  // ******************************************************
  private be = inject(SpringRestService);
  private gmService = inject(GlobalModelService);

  protected execOPE(cb: BaseSpringServiceCB): Observable<any> {
    return this.be.execOPE(this.gmService.composeUrl(), cb);
  }

  protected putEntityImage(url: string, file: File, entityID: string) :Observable<any>{
    return this.be.putEntityImage(this.gmService.composePutImageUrl(url), file, entityID)
  }
}
